// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"361608f70c45f79b","4661":"768bc501da0857bd"}[chunkId] + ".css";
};